import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Flex } from '@finect/tabular-core/Flex';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { Section } from '../../Section';
import { Icon } from '../../Icon';
import { StyledViewMore, Description } from './partials';
export var ManagementCompanyDescription = function ManagementCompanyDescription(_ref) {
  var managementCompany = _ref.managementCompany,
    isPartner = _ref.isPartner;
  if (!managementCompany.organization) {
    return null;
  }
  var urlGroup = isPartner ? "https://www.finect.com/grupos/".concat(managementCompany.organization.alias) : "/grupos/".concat(managementCompany.organization.alias);
  var urlIconGroup = isPartner ? "https://www.finect.com/image/".concat(managementCompany.organization.icon) : "/image/".concat(managementCompany.organization.icon);
  return React.createElement(Section, {
    bottomMargin: true
  }, managementCompany.organization ? React.createElement(Flex, null, React.createElement(Icon, {
    type: "company",
    image: urlIconGroup,
    alt: managementCompany.organization.displayName,
    size: 4,
    verified: true,
    url: managementCompany.organization.features.blog ? urlGroup : null
  }), React.createElement(Description, null, React.createElement(ParagraphSmall, {
    maxWidth: "100%"
  }, managementCompany.organization.description), managementCompany.organization.features.blog ? React.createElement(StyledViewMore, {
    as: "a",
    href: urlGroup
  }, "Ver m\xE1s de ", managementCompany.organization.displayName, React.createElement(ChevronRight, {
    size: "18px",
    strokeWidth: "3"
  })) : null)) : null);
};